module.exports = __webpack_public_path__ + "img/AdobeStock_203008652.0150fb59.jpeg";